export default __webpack_public_path__ + "static/media/linkedin.bd0adbed.webp";